<template>
  <div>
   
  </div>
</template>


<script>
import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

export default {
  name: "Scrmlite",
  components: {
    
  },
  data() {
    return {
 
    };
  },
  computed: {},
  created() {    
      var token = this.$route.query.token;

      // 取得轉址位置
      $.ajax({
        url: webTypeApiUrl.MessageAPI + "/Friend/GetScrmLiteUrl",
        type: "post",
        cache: false,
        async: true,
        data: { },
        dataType: "json",
        success: function (data) {          
          if(!data.Success) {
            alert(data.ErrorMessage);
            return;
          }

          window.location = data.Url + "?token=" + token;
        },
        error: function (a, b, c) {
          console.log(a);
          console.log(b);
          console.log(c);
          alert(c);        
        }
      });            
  },
  methods: {
  
  }
};
</script> 
<style>
</style>



// WEBPACK FOOTER //
// src/components/scrmlite.vue